import { CreateplusMessagesService } from "../../../common/api.service"

export default {
  namespaced: true,
  state: {
    createplusMessages: {},
  },
  mutations: {
    setMessages(state, payload) {
      state.createplusMessages = payload.messages
    },
  },
  actions: {
    async  fetchMessages({ commit }, {lg2, locale}) {
      return await CreateplusMessagesService.get(lg2, locale)
      .then(({ data }) => {
        commit('setMessages', data)
        commit('setLg2', data.lang, { root: true })
        return data
      })
      .catch((reason) => {
        console.log(reason.message)
      })
    },
  },
  getters: {
  }
}